import Vue from "vue";

/**
 * Find the inventory a receiving label refers to.
 *
 * The gate's receiving worksheet becomes exactly one inventory, and its label
 * carries the document number because nothing else links the two: `inventory_id`
 * is null on every receiving entry, so the entry-based lookup the other
 * stickers use has nothing to resolve.
 *
 * The backend search is a LIKE `%documentNumber%`, so `RC26090067` would also
 * return `RC260900671` if such a document existed — narrowed to exact matches
 * here. A document that genuinely holds more than one inventory (208 of 14,750)
 * is handed back for the caller to resolve rather than guessed at, the same way
 * a tied LME lot code is.
 *
 * @returns {Promise<Array<{inventory: Object, unitDetail: null}>>}
 */
export async function findInventoriesByDocumentNumber({
  documentNumber,
  availableOnly = false,
}) {
  if (!documentNumber) {
    return [];
  }
  const resp = await Vue.axios.get(
    "/inventory/search/document/" + encodeURIComponent(documentNumber),
    { params: { page: 0, size: 50, sort: "id,desc", availableOnly } }
  );
  const rows = (resp && resp.data && resp.data.content) || [];
  return rows
    .filter((inventory) => inventory.documentNumber === documentNumber)
    .map((inventory) => ({ inventory, unitDetail: null }));
}
